import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";
import { connect } from "react-redux";

function ProductListingCategory(props) {
  const oldData = (props.listingData && props.listingData.catalogData) || {};
  const newData = (props.listingData && props.listingData.formData) || {};
  const [category, setCategory] = useState(newData.category || "");

  useEffect(() => {
    setCategory(newData.category || "");
  }, [newData.category]);

  const handleNext = () => {
    props.setListingData(prev => ({
      ...prev,
      formData: {
        ...prev.formData,
        category: category
      }
    }));

    props.nextStep();
  };

  return (
    <Container>
      <Row>
        <Col md={12} className="mt-2 mb-2">
          <h4>Step 3 : Category</h4>
        </Col>

        <Col md={12}>
          <Card className="p-4">
            
            <Row className="mb-4 text-center">
              <Col md={2} className="text-left"></Col>
              <Col md={4} className="text-left">
                <span className="text-muted"><b>Old Value</b></span>
              </Col>
              <Col md={6} className="text-left">
                <span className="text-muted"><b>New Value</b></span>
              </Col>
            </Row>

            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">
                Product Type :
              </Col>
              <Col md={4}>
                <p className="mb-0">{oldData.category || "N/A"}</p>
              </Col>
              <Col md={6}>
                <Input
                  type="text"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                />
              </Col>
            </Row>
          </Card>
        </Col>

        <Col md={12} className="mt-3 d-flex justify-content-between">
          <button className="btn btn-light" onClick={props.prevStep}>
            ← Back
          </button>
          <button className="btn btn-primary" onClick={handleNext}>
            Next →
          </button>
        </Col>

      </Row>
    </Container>
  );
}

const mapStateToProps = state => ({
  token: state.loggedUser.token,
  accessLevel: state.loggedUser.accessLevel,
  status: state.loggedUser.status,
});

export default connect(mapStateToProps)(ProductListingCategory);